import AssetViewerPage from './AssetViewerPage';
export default AssetViewerPage;